import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useUpdateForwarder = () => {
  const queryClient = useQueryClient();

  return apiClient.forwarder.updateForwarder.useMutation({
    onSuccess: (_: unknown, variables) => {
      queryClient.invalidateQueries({ queryKey: ['forwarder', variables.body._id] });
      queryClient.invalidateQueries({ queryKey: ['forwarders'] });
      toast.success('Forwarder saved successfully!');
    },
    onError: (error: unknown) => {
      showErrorToast(error, `Error saving the forwarder!`);
    },
  });
};
